
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/performance-analysis-diff",
      function () {
        return require("private-next-pages/performance-analysis-diff.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/performance-analysis-diff"])
      });
    }
  